import React from 'react';
import Image from 'next/image';
import { useSession } from '@/contexts/LitSessionProvider';
import { useRouter } from 'next/router';
import { CATEGORIES, EVENTS, LogToMixpanel } from '@/lib/misc/mixpanel';
import { MEMES_SUB_MENU, ModeValue, SubModeValue, TimeFrames } from '@shared/types/frontend/searchHome';
import { V2Networks } from '@shared/utils/config/networkAddresses';
import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group';
import { Button } from '@/components/ui/button';
import Link from 'next/link';
import { IoTriangle } from 'react-icons/io5';
import { ImageWithFallback } from '@/components/shared/NextImageFallback';
import getNetworkLogo from '@/lib/misc/getNetworkLogo';
import { ScrollArea, ScrollBar } from '@/components/ui/scroll-area';
import { abbreviateNumber, toSpecialFixed } from '@/lib/misc/utils';
import { addImageFallback } from '@/lib/misc/addImageFallback';
import { useRecentToken } from '@/hooks/saved/useRecentToken';
import { useRef } from 'react';
import { useDraggable } from 'react-use-draggable-scroll';
import { useSavedToken } from '@/hooks/saved/useSavedToken';
interface FilterMemeModeProps {
  setMode: (_: ModeValue) => void;
  subMode: SubModeValue;
  setSubMode: React.Dispatch<React.SetStateAction<SubModeValue>>;
  timeFrame: TimeFrames;
  subMemeData: any;
  network: number[];
}
const TrendingMemeToggleGroup = ({
  mode,
  setSubMode
}) => {
  const handleToggle = (value: string) => {
    setSubMode(value);
  };
  const {} = useSavedToken({});
  return <ToggleGroup type='single' value={mode} onValueChange={handleToggle} className='flex justify-start ml-4 mb-4 overflow-x-scroll' data-sentry-element="ToggleGroup" data-sentry-component="TrendingMemeToggleGroup" data-sentry-source-file="MobileMemeMode.tsx">
            {MEMES_SUB_MENU.map(item => <ToggleGroupItem key={item.label} value={item.modeValue} className={`${item.modeValue === mode && 'bg-genius-blue'} data-[state=off]:hover:bg-transparent  disabled:opacity-100 text-[16px] flex gap-1 items-center rounded-[8px] text-genius-cream w-fit h-[32px] py-[3px] px-4`} disabled={item.modeValue === mode}>
                    {item.isImage ? <Image src={`/icons/${item.isImage}`} alt={item.label} width={100} height={100} className='h-[20px] w-[20px]' /> : item.img}
                    <p className=''>{item.label}</p>
                </ToggleGroupItem>)}
        </ToggleGroup>;
};
const MobileMemeMode = ({
  subMode,
  setSubMode,
  timeFrame,
  subMemeData,
  network
}: FilterMemeModeProps) => {
  return <div className='grid gap-2 justify-items-start my-4 overflow-x-scroll no-scrollbar' data-sentry-component="MobileMemeMode" data-sentry-source-file="MobileMemeMode.tsx">
            <TrendingMemeToggleGroup mode={subMode} setSubMode={setSubMode} data-sentry-element="TrendingMemeToggleGroup" data-sentry-source-file="MobileMemeMode.tsx" />
        </div>;
};
export default MobileMemeMode;